module.exports = __webpack_public_path__ + "contacts-cbf4f629/kununuLogo-95638cc24594e9ceb45321d65d915dd3.svg";